import Navigation from './components/navigation'
import Home from './components/home'
import QuienesSomos from './components/quienessomos';
import Servicios from './components/servicios';
import Testimonios from './components/testimonios';
import NuestroEquipo from './components/nuestroEquipo';
import Contacto from './components/contacto';
import Footer from './components/footer'

function App() {
  return (
    <div className="App">
      <Navigation/>
      <Home/>
      <QuienesSomos/>
      <Servicios/>
      <Testimonios/>
      <NuestroEquipo/>
      <Contacto/>
      <Footer/>
    </div>
  );
}

export default App;
